import React from 'react';
import CheckIcon from '@mui/icons-material/Check';

import strings from '../../constant/strings';
import { Step, Steps } from './styles';

/**
 * Where the patient is in the pre-order flow.
 *
 * The three steps are the three screens a new visitor passes through: choose
 * the device and agree the terms, create an account, confirm the emailed code.
 * The order is placed at the end of the third.
 *
 * Someone already signed in skips the last two entirely - they reserve in a
 * single action - so the bar is not rendered for them at all. Showing three
 * steps to someone with one to do would be a lie about how much is left.
 */
export const PREORDER_STEPS = [
  strings.stepChooseDevice,
  strings.stepCreateAccount,
  strings.stepConfirmEmail,
];

export default function PreorderSteps({ current, hidden = false }) {
  if (hidden) return null;

  return (
    <Steps aria-label={strings.preorderProgress}>
      {PREORDER_STEPS.map((label, index) => {
        const state = index < current ? 'done' : index === current ? 'current' : 'upcoming';
        return (
          <Step
            key={label}
            data-state={state}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <span className="marker" aria-hidden>
              {state === 'done' ? <CheckIcon sx={{ fontSize: 17 }} /> : index + 1}
            </span>
            <span className="label">{label}</span>
          </Step>
        );
      })}
    </Steps>
  );
}
